import type { LocalStorageValues } from "../constants/LocalStorageItems";

export abstract class LocalStorage {
  public static saveItem<T>(key: LocalStorageValues, item: T) {
    localStorage.setItem(key, JSON.stringify(item));
  }

  public static getItem<T>(key: LocalStorageValues): T {
    const jsonWithData = localStorage.getItem(key)!;

    return jsonWithData ? JSON.parse(jsonWithData) : {};
  }
}
